















import { defineComponent, PropType, SetupContext } from '@vue/composition-api';

import ScheduleTag from '@/base/app/components/atoms/ScheduleTag.vue';
import BaseTable from '@/base/app/components/molecules/BaseTable.vue';

import {
  PropsScheduleTable,
  ScheduleTagTableItem,
  useScheduleTagTable,
} from './ScheduleTagTableComposable';

type Props = PropsScheduleTable;

export default defineComponent({
  name: 'TrainingScheduleTagTable',
  components: { BaseTable, ScheduleTag },
  inheritAttrs: false,
  props: {
    tags: { type: Array as PropType<ScheduleTagTableItem[]>, default: () => [] },
    headerKeys: { type: Array as PropType<string[]>, default: () => ['text', 'preview'] },
  },
  emits: ['action'],
  setup(props: Props, { emit }: SetupContext) {
    return useScheduleTagTable(props, emit);
  },
});
